import { FC } from "react";
import {
  baseUrl,
  toAbsoluteUrl,
  XHR,
  valortotalDocumentosSeleccionados,
  JWT,
} from "../../../helpers";
import { Iestado } from "../../../helpers/dataExamples";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";
import { REACT_APP_AMBIENTE_EPAYCO } from "../../../../parametros";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type tipos = {
  amount: number;
  name: string;
  descrip: string;
  email: string;
  estado: Iestado;
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>;
  stpb: React.Dispatch<React.SetStateAction<boolean>>;
};

const EpaycoCheckOut: FC<tipos> = ({
  amount,
  name,
  descrip,
  email,
  estado,
  setEstado,
  stpb,
}) => {
  const referencias = Object.keys(estado.referencias);

  const MySwal = withReactContent(Swal);

  const dataTransaccion = {
    descripcionProducto: name,
    documentoCliente: estado.documento,
    tipoDocCliente: estado.tipoDocumento,
    nombreCliene: estado.nombres + " " + estado.apellidos,
    telefono: estado.telefono,
    email: estado.correo,
    direccion: estado.direccion,
    valorTotal: valortotalDocumentosSeleccionados(estado),
    idServicio: estado.idServicio,
    fechaVencimiento:
      isNaN(Date.parse(estado.fechaVencimiento)) === true
        ? moment(new Date()).format("YYYY-MM-DD")
        : estado.fechaVencimiento,
    ListDocumento: Array<object>(),
  };

  referencias.forEach((ref, index) => {
    const hacerAbono = estado.referencias[ref].hacer_abono;
    let docu: object = {
      numeroDocumento: estado.referencias[ref].referencia,
      valorDocumento: estado.referencias[ref].valorTotal,
      valorAbono: estado.referencias[ref].valor_abono,
      valorApagar: hacerAbono
        ? estado.referencias[ref].valor_abono
        : estado.referencias[ref].valorMinimo,
      detalleDocumento: estado.referencias[ref].descrip,
      codigoServicio: estado.referencias[ref].codigoServicioSAP,
      fechaVencimiento:
        isNaN(Date.parse(estado.fechaVencimiento)) === true
          ? moment(new Date()).format("YYYY-MM-DD")
          : estado.referencias[ref].limite,
    };
    dataTransaccion.ListDocumento.push(docu);
  });

  const makePay = () => {
    let myWin = window as any;

    if (typeof myWin.ePayco == "object") {

      var payload = {
        sessionId: estado.sessionId,
        type: "standard", // "onpage" | "standard"
      }

      var checkout = myWin.ePayco.checkout.configure(payload);

      checkout.open();
    }
  };

  const intencionDePago = async () => {

    if (validacionTransaccion() === false) {
      alert("Ocurrio un error en la operación intente de nuevo mas tarde(2)!");
      window.location.reload();
    }

    MySwal.fire({
      title: "<strong>¿Está seguro de continuar con el pago?</strong>",
      icon: "info",
      //html: "<strong>¿Esta seguro de continuar con el pago?</strong>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Continuar",
      confirmButtonAriaLabel: "Thumbs up, great!",
      cancelButtonText: "Cancelar",
      cancelButtonAriaLabel: "Thumbs down",
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      //console.log(result);
      if (result.isConfirmed) {
        let url = baseUrl() + "Transacciones/crearTransaccionEpayco";
        const token = await JWT("PAGOS_EN_LINEA");
        var _headers = { Authorization: "Bearer " + token };


        const resp = await XHR(stpb, url, dataTransaccion, "post", _headers);
        if (resp?.data.exito) {
          const newState = { ...estado };
          estado.guidTransaccion = resp.data.data.id;
          estado.sessionId = resp.data.data.sessionId;
          setEstado(newState);
          stpb(true);
          makePay();
        } else {
          //alert(resp?.data.mensaje);
          MySwal.fire({
            title: resp?.data.mensaje,
            icon: "error",
            //html: "<strong>¿Esta seguro de continuar con el pago?</strong>",
            showCloseButton: true,
            focusConfirm: false,
            confirmButtonText: "Continuar",
            confirmButtonAriaLabel: "Thumbs up, great!",
            cancelButtonAriaLabel: "Thumbs down",
          }).then(async (result) => {
            window.location.reload();
          });
        }
      }
    });
  };

  const validacionTransaccion = (): boolean => {
    if (dataTransaccion.documentoCliente.trim() === "" ||
      dataTransaccion.tipoDocCliente.trim() === "" ||
      dataTransaccion.valorTotal === 0 ||
      Number.isNaN(dataTransaccion.valorTotal)
    ) {
      return false;
    } else {
      return true;
    }
  }

  /*return (
    <a className="btn-epayco" onClick={intencionDePago} href="#/">
      <img
        src={toAbsoluteUrl("/media/icons/boton_de_cobro_epayco2.png")}
        alt=""
      ></img>
    </a>
  );*/

  return (
    <a className="btn btn-comfe rounded-pill" onClick={intencionDePago} href="#/">
      <FontAwesomeIcon icon={"dollar-sign"} /> Pagar Aquí
    </a>
  );
};

export { EpaycoCheckOut };
